module.exports = __webpack_public_path__ + "img/coin_grab_brown.19d71ca8.png";